import { FC } from 'react';
import { Weights } from '../enums';
import { ButtonSelect } from '.';
import { weightItems } from '../constants';

interface Props {
  weightValue: Weights;
  label: string;
  keyWeightEl: string;
  handleWeightValueChange: (keyEl: string, value: Weights) => void;
}

const AdvancedWeightContent: FC<Props> = ({
  weightValue,
  keyWeightEl,
  label,
  handleWeightValueChange,
}) => (
  <div className="flex items-center justify-between gap-2">
    <span className="flex-1 text-xs text-slate-600">{label}</span>
    <ButtonSelect
      className="self-right"
      label={label}
      ariaLabel={label}
      items={weightItems}
      value={weightValue}
      handleValueChange={(value: string) =>
        handleWeightValueChange(keyWeightEl, parseInt(value, 10))
      }
    />
  </div>
);

export default AdvancedWeightContent;
